import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import "./Table.css";
import { Table as Tableantd } from "antd";
import { CSVLink } from "react-csv";
import userContext from "../../context/user-context";
import ccode_branchmap from "../../data/seatmatrix-2026.json";
import sub_keymap from "../../data/subkey_map.json";
import { unparse as PapaUnparse } from "papaparse";
import {
	FiHash,
	FiHeart,
	FiAward,
	FiShield,
	FiFlag,
	FiMapPin,
	FiDownload,
	FiDownloadCloud,
	FiSearch,
	FiUsers,
	FiDatabase,
	FiInbox,
	FiLayers
} from "react-icons/fi";

export const Table = () => {
	// const api = "http://localhost:8080/";
	// const api = "http://13.235.45.99/";
	const api = "https://collegeportal.tngasa.in/";

	const navigate = useNavigate();

	const { clgcode } = useContext(userContext);
	const [tabledata, setTabledata] = useState([]);
	const [exceldownloaddata, setExceldownloaddata] = useState([]);
	const [bcode, setbcode] = useState("");
	const [isloading, setIsloading] = useState(false);
	const [downloadinflag, setDownloadinflag] = useState(false);
	const [isdatafetched, setIsdatafetched] = useState(false);
	const [branchwise_count, setBranchwise_count] = useState(0);
	const [loading2, setLoading2] = useState(false);

	console.log(clgcode);

	const options2 = ccode_branchmap.filter((data) => {
		return data.colCode == parseInt(clgcode);
	});

	const DIFF_ABLED_TYPES = [
		{ key: "1", label: "Blindness" },
		{ key: "2", label: "Low-vision" },
		{ key: "3", label: "Leprosy Cured persons" },
		{ key: "4", label: "Hearing Impairment (deaf and hard of hearing)" },
		{ key: "5", label: "Locomotor Disability" },
		{ key: "6", label: "Acid Attack Victim" },
		{ key: "7", label: "Dwarfism" },
		{ key: "8", label: "Intellectual Disability" },
		{ key: "9", label: "Mental Illness" },
		{ key: "10", label: "Autism Spectrum Disorder" },
		{ key: "11", label: "Cerebral Palsy" },
		{ key: "12", label: "Muscular Dystrophy" },
		{ key: "13", label: "Chronic Neurological Conditions" },
		{ key: "14", label: "Specific Learning Disabilities" },
		{ key: "15", label: "Multiple Sclerosis" },
		{ key: "16", label: "Speech and Language disability" },
		{ key: "17", label: "Thalassemia" },
		{ key: "18", label: "Hemophilia" },
		{ key: "19", label: "Sickle Cell Disease" },
		{ key: "20", label: "Multiple Disabilities including deaf blindness" },
		{ key: "21", label: "Parkinson's disease" }
	];

	const SPORTS_LEVEL_OF_PARTICIPATION = [
		{ key: "1", label: "District" },
		{ key: "2", label: "Divisional" },
		{ key: "3", label: "State" },
		{ key: "4", label: "National" },
		{ key: "5", label: "International" },
		{ key: "6", label: "None of the above" },
	];

	const SECURITY_FORCES_OPTS = [
		{ key: "1", label: "Widows/wards of Defense personnel killed in action" },
		{
			key: "2",
			label: "Wards of serving personnel and ex-servicemen disabled in action",
		},
		{
			key: "3",
			label:
				"Widows/Wards of Defense personnel who died in peace time with death attributable to Military service.",
		},
		{
			key: "4",
			label:
				"Wards of Defense personnel disabled in peace time with disability attributable to military service",
		},
		{
			key: "5",
			label:
				"Wards of Ex-servicemen personnel and serving police forces who are in receipt of Gallantry Awards (Gallaniry Awards include : Paramvir Chakra, Ashok Chakra, SarvottamYudhSeva Medal, MahaVir Chakra, Kirti Chakra, UitamYudhseva Medal, Vir Chakra, Shaurya Chakra, Yudhseva Medal Sena,  Nausena-Vayusena Medal.)",
		},
		{
			key: "6",
			label: "President Police Medal for Gallantry' Police medal for Gallantry",
		},
		{ key: "7", label: "None of the Above" },
	];

	const dimention_changer = (list) => {
		console.log(list);
		const temp = removeDuplicates(list, "_aid");
		console.log(temp);
		temp.map((data) => {
			var choices = "";
			list.map((data2) => {
				if (data._aid === data2._aid) {
					choices = choices + " " + data2.bcode;
					console.log(data._aid);
				}
			});
			data["choice_list"] = choices;
			return data;
		});

		console.log(temp);

		return temp;
	};

	const diffid_to_name = (id) => {
		// console.log(id);
		const type = DIFF_ABLED_TYPES.find((data) => data.key === id);
		return type.label;
	};

	const sportid_to_name = (id) => {
		const type = SPORTS_LEVEL_OF_PARTICIPATION.find((data) => data.key === id);
		return type.label;
	};

	const security_forces_to_name = (id) => {
		const type = SECURITY_FORCES_OPTS.find((data) => data.key === id);
		return type.label;
	};

	const options = [
		{ value: "ATTE1", label: "ATTE1" },
		{ value: "APAE1", label: "APAE1" },
		{ value: "SPHE1", label: "SPHE1" },
	];

	const isadvanced = (data) => {
		var flag = false;
		if (
			data.s1 == "2" ||
			data.s2 == "2" ||
			data.s3 == "2" ||
			data.s4 == "2" ||
			data.s5 == "2" ||
			data.s6 == "2"
		) {
			flag = true;
		}

		if (data.s6 !== undefined || data.s6 !== null) {
			if (data.s6 == "2") {
				flag = true;
			}
		}

		return flag;
	};

	const istamilstudied = (data) => {
		var flag = false;
		if (
			data.s1 == "73" ||
			data.s2 == "73" ||
			data.s3 == "73" ||
			data.s4 == "73" ||
			data.s5 == "73" ||
			data.s6 == "73"
		) {
			flag = true;
		}

		if (data.s6 !== undefined || data.s6 !== null) {
			if (data.s6 == "74") {
				flag = true;
			}
		}

		return flag;
	};

	const r1list = [
		"LTLT1",
		"LTLT2",
		"LTAT1",
		"LTAT2",
		"LMAE1",
		"LTET1",
		"LTET2",
		"LURE1",
		"LHDE1",
		"LSAE1",
	];

	const r2list = ["LENE1", "LENE1M", "LENE2"];

	const tamil_list = ["LTLT1", "LTLT2", "LTAT1", "LTAT2"];

	const isr1 = (value) => {
		if (r1list.includes(value)) {
			return true;
		} else {
			return false;
		}
	};

	const isr2 = (value) => {
		if (r2list.includes(value)) {
			return true;
		} else {
			return false;
		}
	};

	const isr3 = (value) => {
		if (!r1list.includes(value) && !r2list.includes(value)) {
			return true;
		} else {
			return false;
		}
	};

	const istamilbranch = (value) => {
		if (tamil_list.includes(value)) {
			return true;
		} else {
			return false;
		}
	};

	const sub_to_name = (sub_code) => {
		// console.log()

		var subname = sub_keymap.find(
			(data) => data.s_no.toString() == sub_code
		).sub_name;

		return subname;
	};

	const sub_to_name2 = (sub_code) => {
		// console.log()

		var subname = sub_keymap.find((data) => data.s_no.toString() == sub_code);

		if (subname === null || subname === undefined) {
			console.log(sub_code);
			return "No data";
		}

		return subname.sub_name;
	};

	const hg_to_data = (hg) => {
		if (hg == null || hg == 1) {
			return "Academic";
		} else {
			return "Vocational";
		}
	};

	const subs_to_data = (record) => {
		var subsstudied = "";
		if (record.s1 !== undefined && record.s1 !== null) {
			subsstudied = subsstudied + "1." + sub_to_name2(record.s1) + "\t";
		}
		if (record.s2 !== undefined && record.s2 !== null) {
			subsstudied = subsstudied + "2." + sub_to_name2(record.s2) + "\t";
		}
		if (record.s3 !== undefined && record.s3 !== null) {
			subsstudied = subsstudied + "3." + sub_to_name(record.s3) + "\t";
		}
		if (record.s4 !== undefined && record.s4 !== null) {
			subsstudied = subsstudied + "4." + sub_to_name2(record.s4) + "\t";
		}
		if (record.s5 !== undefined && record.s5 !== null) {
			subsstudied = subsstudied + "5." + sub_to_name2(record.s5) + "\t";
		}
		if (record.s6 !== undefined && record.s6 !== null) {
			subsstudied = subsstudied + "6." + sub_to_name2(record.s6) + "\t";
		}

		return subsstudied;
	};

	// function removeDuplicates(array, key) {
	// 	const seen = new Set();
	// 	return array.filter((obj) => {
	// 		const keyValue = obj[key];
	// 		if (seen.has(keyValue)) {
	// 			obj.bcode += appendString;
	// 			return false;
	// 		}
	// 		seen.add(keyValue);
	// 		return true;
	// 	});
	// }

	function removeDuplicates(array, key) {
		const map = new Map();

		// Step 1: Accumulate data in a single loop
		array.forEach((obj) => {
			const keyValue = obj[key];
			if (!map.has(keyValue)) {
				map.set(keyValue, {
					...obj,
					cnos: [],
					bcodes: [],
					bnames: [],
				});
			}

			const entry = map.get(keyValue);
			entry.cnos.push(obj.cno);
			entry.bcodes.push(obj.bcode);
			entry.bnames.push(obj.bname);
		});

		// Step 2: Process accumulated data to normalize cno and construct bcode and bname
		map.forEach((value, key) => {
			// Sort cnos as integers and get corresponding indices
			const sortedIndices = value.cnos
				.map((cno, index) => ({ cno: parseInt(cno, 10), index }))
				.sort((a, b) => a.cno - b.cno)
				.map((item) => item.index);

			// Construct new bcode and bname with normalized cnos
			value.bcode = sortedIndices
				.map((index, newIndex) => `${newIndex + 1}.${value.bcodes[index]}`)
				.join(" | ");
			value.bname = sortedIndices
				.map((index, newIndex) => `${newIndex + 1}.${value.bnames[index]}`)
				.join(" | ");

			// Clean up the value object
			delete value.cnos;
			delete value.bcodes;
			delete value.bnames;
			delete value.cno; // Remove original cno if not needed
		});

		// Step 3: Return the resulting array from the map values
		return Array.from(map.values());
	}

	const exdownload = async () => {
		// Perform the fetch call to get the array of objects
		fetch(`${api}api/ex?clgid=${clgcode}`)
			.then((response) => response.json())
			.then((data) => {
				console.log(data);

				const temp = dimention_changer(data.result);

				var sorteddata = temp.sort((a, b) => {
					return parseFloat(a.r3) - parseFloat(b.r3);
				});

				// Convert the fetched data to CSV format
				const csvData = sorteddata.map((item) => ({
					// Map the item properties to match your CSV columns

					Application_no: item._aid,
					Name: item.name,
					Gender: item.g,
					Community: item.comm,
					Stream: hg_to_data(item.hg),
					Subjects_Studied: subs_to_data(item),
					Mobile: item.m,
					Alt_Mobile: item.alm,
					Email: item.e,
					Communication_Address: item.coa,
					Permanent_Address: item.pa,
					Date_of_Birth: item.dob,
					Branch_choice: item.choice_list,
					Community_as_per_CRA: item.cracomm,
					DPI_Matched:
						item.df === null || item.df === undefined
							? "To Be Verified"
							: item.df,
					Aggregate: item.tot,
				}));

				// const Delremcsvdata = removeDuplicates(csvData, "Application_no");

				// Trigger the CSV download
				const csvDataString = PapaUnparse(csvData);
				const csvBlob = new Blob([csvDataString], { type: "text/csv" });
				const csvUrl = URL.createObjectURL(csvBlob);
				const link = document.createElement("a");
				link.href = csvUrl;
				link.download = `${clgcode}_Ex_service.csv`;
				link.click();
				URL.revokeObjectURL(csvUrl);
				setDownloadinflag(false);
			})
			.catch((error) => {
				console.error("Error fetching data:", error);
			});
	};

	const nccdownload = async () => {
		// Perform the fetch call to get the array of objects
		fetch(`${api}api/ncc?clgid=${clgcode}`)
			.then((response) => response.json())
			.then((data) => {
				console.log(data);

				const temp = dimention_changer(data.result);

				var sorteddata = temp.sort((a, b) => {
					return parseFloat(a.r3) - parseFloat(b.r3);
				});

				// Convert the fetched data to CSV format
				const csvData = sorteddata.map((item) => ({
					// Map the item properties to match your CSV columns

					Application_no: item._aid,
					Name: item.name,
					Gender: item.g,
					Community: item.comm,
					Stream: hg_to_data(item.hg),
					Subjects_Studied: subs_to_data(item),

					Mobile: item.m,
					Alt_Mobile: item.alm,
					Email: item.e,
					Communication_Address: item.coa,
					Permanent_Address: item.pa,
					Branch_choice: item.choice_list,
					Date_of_Birth: item.dob,
					Community_as_per_CRA: item.cracomm,
					DPI_Matched:
						item.df === null || item.df === undefined
							? "To Be Verified"
							: item.df,
					Aggregate: item.tot,
				}));
				// const Delremcsvdata = removeDuplicates(csvData, "Application_no");

				// Trigger the CSV download
				const csvDataString = PapaUnparse(csvData);
				const csvBlob = new Blob([csvDataString], { type: "text/csv" });
				const csvUrl = URL.createObjectURL(csvBlob);
				const link = document.createElement("a");
				link.href = csvUrl;
				link.download = `${clgcode}_ncc.csv`;
				link.click();
				URL.revokeObjectURL(csvUrl);
				setDownloadinflag(false);
			})
			.catch((error) => {
				console.error("Error fetching data:", error);
			});
	};

	const antsdownload = async () => {
		// Perform the fetch call to get the array of objects
		fetch(`${api}api/ants?clgid=${clgcode}`)
			.then((response) => response.json())
			.then((data) => {
				console.log(data);
				const dimention = dimention_changer(data.result);

				var sorteddata = dimention.sort((a, b) => {
					return parseFloat(a.r3) - parseFloat(b.r3);
				});
				// Convert the fetched data to CSV format
				const csvData = sorteddata.map((item) => ({
					// Map the item properties to match your CSV columns

					Application_no: item._aid,
					Name: item.name,
					Gender: item.g,
					Community: item.comm,
					Stream: hg_to_data(item.hg),
					Subjects_Studied: subs_to_data(item),
					Mobile: item.m,
					Alt_Mobile: item.alm,
					Email: item.e,
					Communication_Address: item.coa,
					Permanent_Address: item.pa,
					Branch_choice: item.choice_list,
					Date_of_Birth: item.dob,
					Community_as_per_CRA: item.cracomm,
					DPI_Matched:
						item.df === null || item.df === undefined
							? "To Be Verified"
							: item.df,
					Aggregate: item.tot,
				}));

				// const Delremcsvdata = removeDuplicates(csvData, "Application_no");

				// Trigger the CSV download
				const csvDataString = PapaUnparse(csvData);
				const csvBlob = new Blob([csvDataString], { type: "text/csv" });
				const csvUrl = URL.createObjectURL(csvBlob);
				const link = document.createElement("a");
				link.href = csvUrl;
				link.download = `${clgcode}_andaman&nicobar.csv`;
				link.click();
				URL.revokeObjectURL(csvUrl);
				setDownloadinflag(false);
			})
			.catch((error) => {
				console.error("Error fetching data:", error);
			});
	};

	const sportsdownload = async () => {
		// Perform the fetch call to get the array of objects
		fetch(`${api}api/sports?clgid=${clgcode}`)
			.then((response) => response.json())
			.then((data) => {
				console.log(data);

				const temp1 = dimention_changer(data.result);

				var filteredData = temp1.filter(
					(a) => a.espr !== 0 && a.espr !== null && a.espr !== undefined
				);

				var sorteddata = filteredData.sort((a, b) => {
					return parseFloat(a.espr) - parseFloat(b.espr);
				});

				const csvData = sorteddata.map((item) => ({
					// Map the item properties to match your CSV columns
					Application_no: item._aid,
					Name: item.name,
					Gender: item.g,
					Community: item.comm,
					Stream: hg_to_data(item.hg),
					Subjects_Studied: subs_to_data(item),
					category: sportid_to_name(item.slp),
					Mobile: item.m,
					Alt_Mobile: item.alm,
					Email: item.e,
					Communication_Address: item.coa,
					Permanent_Address: item.pa,
					Branch_choice: item.choice_list,
					Date_of_Birth: item.dob,
					Community_as_per_CRA: item.cracomm,
					DPI_Matched:
						item.df === null || item.df === undefined
							? "To Be Verified"
							: item.df,
					Aggregate_marks: item.tot,
				}));

				// const removekey6 = csvData.filter((obj) => obj.slp !== "6");

				// const Delremcsvdata = removeDuplicates(csvData, "Application_no");

				// Trigger the CSV download
				const csvDataString = PapaUnparse(csvData);
				const csvBlob = new Blob([csvDataString], { type: "text/csv" });
				const csvUrl = URL.createObjectURL(csvBlob);
				const link = document.createElement("a");
				link.href = csvUrl;
				link.download = `${clgcode}_sports.csv`;
				link.click();
				URL.revokeObjectURL(csvUrl);
				setDownloadinflag(false);
			})
			.catch((error) => {
				console.error("Error fetching data:", error);
			});
	};

	const dapdownload = async () => {
		// Perform the fetch call to get the array of objects
		fetch(`${api}api/dap?clgid=${clgcode}`)
			.then((response) => response.json())
			.then((data) => {
				console.log(data);
				const temp = dimention_changer(data.result);

				var sorteddata = temp.sort((a, b) => {
					return parseFloat(a.r3) - parseFloat(b.r3);
				});
				// Convert the fetched data to CSV format
				const csvData = sorteddata.map((item) => ({
					// Map the item properties to match your CSV columns

					Application_no: item._aid,
					Name: item.name,
					Gender: item.g,
					Community: item.comm,
					Stream: hg_to_data(item.hg),
					Subjects_Studied: subs_to_data(item),
					category: diffid_to_name(item.adt),

					Mobile: item.m,
					Alt_Mobile: item.alm,
					Email: item.e,
					Communication_Address: item.coa,
					Permanent_Address: item.pa,
					Branch_choice: item.choice_list,
					Date_of_Birth: item.dob,
					Community_as_per_CRA: item.cracomm,
					Percentage_of_disability: item.perdis,
					DPI_Matched:
						item.df === null || item.df === undefined
							? "To Be Verified"
							: item.df,
					Aggregate_marks: item.tot,
				}));

				// const Delremcsvdata = removeDuplicates(csvData, "Application_no");

				// Trigger the CSV download
				const csvDataString = PapaUnparse(csvData);
				const csvBlob = new Blob([csvDataString], { type: "text/csv" });
				const csvUrl = URL.createObjectURL(csvBlob);
				const link = document.createElement("a");
				link.href = csvUrl;
				link.download = `${clgcode}_disabled.csv`;
				link.click();
				URL.revokeObjectURL(csvUrl);
				setDownloadinflag(false);
			})
			.catch((error) => {
				console.error("Error fetching data:", error);
			});
	};

	const securityforcesdownload = async () => {
		// Perform the fetch call to get the array of objects
		fetch(`${api}api/secforce?clgid=${clgcode}`)
			.then((response) => response.json())
			.then((data) => {
				console.log(data);
				const temp1 = dimention_changer(data.result);

				var sorteddata = temp1.sort((a, b) => {
					return parseFloat(a.r3) - parseFloat(b.r3);
				});

				// Convert the fetched data to CSV format
				const csvData = sorteddata.map((item) => ({
					// Map the item properties to match your CSV columns

					Application_no: item._aid,
					Name: item.name,
					Gender: item.g,
					Community: item.comm,
					Stream: hg_to_data(item.hg),
					Subjects_Studied: subs_to_data(item),
					category: security_forces_to_name(item.psf),
					Mobile: item.m,
					Alt_Mobile: item.alm,
					Email: item.e,
					Communication_Address: item.coa,
					Permanent_Address: item.pa,
					Branch_choice: item.choice_list,
					Date_of_Birth: item.dob,
					Community_as_per_CRA: item.cracomm,
					DPI_Matched:
						item.df === null || item.df === undefined
							? "To Be Verified"
							: item.df,
					Aggregate_marks: item.tot,
				}));

				// const Delremcsvdata = removeDuplicates(csvData, "Application_no");

				// Trigger the CSV download
				const csvDataString = PapaUnparse(csvData);
				const csvBlob = new Blob([csvDataString], { type: "text/csv" });
				const csvUrl = URL.createObjectURL(csvBlob);
				const link = document.createElement("a");
				link.href = csvUrl;
				link.download = `${clgcode}_securityforces.csv`;
				link.click();
				URL.revokeObjectURL(csvUrl);
				setDownloadinflag(false);
			})
			.catch((error) => {
				console.error("Error fetching data:", error);
			});
	};

	// The dedup/filter/sort/CSV build now happens on the server — the browser
	// just downloads the finished CSV (a few hundred KB) instead of pulling and
	// processing the full ~146MB choice-row dump.
	const downloadPartCsv = async (part) => {
		try {
			const response = await fetch(
				`${api}api/part/csv?clgid=${clgcode}&part=${part}`
			);
			if (!response.ok) {
				throw new Error(`Server responded ${response.status}`);
			}
			const csvBlob = await response.blob();
			const csvUrl = URL.createObjectURL(csvBlob);
			const link = document.createElement("a");
			link.href = csvUrl;
			link.download = `${clgcode}_part${part}.csv`;
			link.click();
			URL.revokeObjectURL(csvUrl);
		} catch (error) {
			console.error("Error fetching data:", error);
		} finally {
			setDownloadinflag(false);
		}
	};

	const part1download = () => downloadPartCsv(1);
	const part2download = () => downloadPartCsv(2);
	const part3download = () => downloadPartCsv(3);

	const columns = [
		{
			title: "Rank",
			dataIndex: "rank",
			key: "12",
		},
		// {
		// 	title: "OgRank",
		// 	dataIndex: "ogrank",
		// 	key: "1"
		// },
		{
			title: "RegNo",
			dataIndex: "_aid",
			key: "2",
		},
		{
			title: "Name",
			dataIndex: "name",
			key: "25",
		},
		{
			title: "Email",
			dataIndex: "e",
			key: "3",
		},
		{
			title: "Gender",
			dataIndex: "g",
			key: "4",
		},
		{
			title: "Community",
			dataIndex: "comm",
			key: "5",
		},
		{
			title: "Stream",
			render: (id, record, index) => {
				if (record.hg == null || record.hg == 1) {
					return "Academic";
				} else {
					return "Vocational";
				}
			},
			key: "6",
		},
		{
			title: "Aggregate Mark",
			dataIndex: "agg",
			key: "7",
		},
		{
			title: "Sub Stud",
			render: (id, record, index) => {
				var subsstudied = "";
				if (record.s1 !== undefined && record.s1 !== null) {
					subsstudied = subsstudied + "1." + sub_to_name(record.s1) + "\t";
				}
				if (record.s2 !== undefined && record.s2 !== null) {
					subsstudied = subsstudied + "2." + sub_to_name(record.s2) + "\t";
				}
				if (record.s3 !== undefined && record.s3 !== null) {
					subsstudied = subsstudied + "3." + sub_to_name(record.s3) + "\t";
				}
				if (record.s4 !== undefined && record.s4 !== null) {
					subsstudied = subsstudied + "4." + sub_to_name(record.s4) + "\t";
				}
				if (record.s5 !== undefined && record.s5 !== null) {
					subsstudied = subsstudied + "5." + sub_to_name(record.s5) + "\t";
				}
				if (record.s6 !== undefined && record.s6 !== null) {
					subsstudied = subsstudied + "6." + sub_to_name(record.s6) + "\t";
				}

				return subsstudied;
			},
			key: "8",
		},
		{
			title: "Choice No",
			dataIndex: "cno",
			key: "26",
		},
		{
			title: "Date of Birth",
			dataIndex: "dob",
			key: "89",
		},
		{
			title: "Alt Mobile",
			dataIndex: "alm",
			key: "10",
		},
		{
			title: "Mobile",
			dataIndex: "m",
			key: "9",
		},
		{
			title: "Community_as_per_CRA",
			dataIndex: "cracomm",
			key: "11",
		},
		{
			title: "Alt Mobile",
			dataIndex: "alm",
			key: "10",
		},
	];

	const getdata = () => {
		setIsloading(true);
		fetch(`${api}api/list?clgid=${clgcode}&bid=${bcode}`)
			.then((data) => data.json())
			.then((result) => {
				// console.log(result.result.length);
				// return;
				var tablepredata = result.result;
				var newArrayOfObj = [];
				if (isr1(bcode)) {
					newArrayOfObj = tablepredata.map(
						({ r1: ogrank, rks1: agg, ...rest }) => ({
							agg,
							ogrank,
							...rest,
						})
					);
				}
				if (isr2(bcode)) {
					newArrayOfObj = tablepredata.map(
						({ r2: ogrank, rks2: agg, ...rest }) => ({
							agg,
							ogrank,
							...rest,
						})
					);
				}
				if (isr3(bcode)) {
					newArrayOfObj = tablepredata.map(
						({ r3: ogrank, tot: agg, ...rest }) => ({
							agg,
							ogrank,
							...rest,
						})
					);
				}

				var sorteddata = [];

				if (istamilbranch(bcode)) {
					console.log(newArrayOfObj);
					var advtamilstudents = newArrayOfObj.filter((data) =>
						isadvanced(data)
					);
					var nontamilsadvtudets = newArrayOfObj.filter((data) => {
						if (isadvanced(data)) {
							return false;
						} else {
							return true;
						}
					});

					var onlytamil = nontamilsadvtudets.filter((data) =>
						istamilstudied(data)
					);
					var notamilatall = nontamilsadvtudets.filter((data) => {
						if (istamilstudied(data)) {
							return false;
						} else {
							return true;
						}
					});

					var wholetamillist = [];

					var advtamilstudentssorted = advtamilstudents.sort((a, b) => {
						return parseFloat(a.ogrank) - parseFloat(b.ogrank);
					});

					var onlytamilsorted = onlytamil.sort((a, b) => {
						return parseFloat(a.ogrank) - parseFloat(b.ogrank);
					});

					var notamilatallsorted = notamilatall.sort((a, b) => {
						return parseFloat(a.ogrank) - parseFloat(b.ogrank);
					});

					var temp = wholetamillist.concat(advtamilstudentssorted);
					var temp1 = temp.concat(onlytamilsorted);
					var temp2 = temp1.concat(notamilatallsorted);

					sorteddata = temp2;
				} else {
					sorteddata = newArrayOfObj.sort((a, b) => {
						return parseFloat(a.ogrank) - parseFloat(b.ogrank);
					});
				}

				console.log(sorteddata);

				sorteddata.map((value, index) => {
					value["rank"] = index + 1;
					delete value["ants"];
					delete value["dap"];
					delete value["ex"];
					delete value["ncc"];
					delete value["ogrank"];
					delete value["psf"];
					delete value["r1"];
					delete value["r2"];
					delete value["rno"];
					delete value["vsc"];
					delete value["_id"];
					delete value["pn"];
					delete value["dist"];
					delete value["stat"];
					delete value["rel"];
					delete value["cas"];
					delete value["aa"];
					delete value["pin"];
					return value;
				});

				var exceldata = [];

				sorteddata.map((data) => {
					var temp = {
						rank: data.rank,
						"Admission No": data._aid,
						Name: data.name,
						Gender: data.g,
						Community: data.comm,
						Stream: hg_to_data(data.hg),
						Agg_Mark: data.agg,
						DPI_Status:
							data.df === null || data.df === undefined
								? "To Be Verified"
								: data.df,
						Subjects_Studied: subs_to_data(data),
						Choice_Number: data.cno,
						Mobile: data.m,
						Alt_Mobile: data.alm,
						Communication_Address: data.coa,
						Permanent_Address: data.pa,
						Email: data.e,
						Date_of_Birth: data.dob,
						Community_as_per_CRA: data.cracomm
					};

					exceldata.push(temp);
				});

				setBranchwise_count(sorteddata.length);
				setLoading2(true);
				setExceldownloaddata(exceldata);
				setTabledata(sorteddata);
				setIsloading(false);
				setIsdatafetched(true);
			});
	};

	const getcount = () => {
		fetch(`${api}api/count?clgid=${clgcode}&bid=${bcode}`)
			.then((data) => data.json())
			.then((result) => {
				setBranchwise_count(result.result.count);
				setLoading2(true);
				console.log(result);
			});
	};

	useEffect(() => {
		if (clgcode == 0) {
			navigate("/");
		}
	}, []);

	// — Warm light react-select theme —
	const selectStyles = {
		control: (base, state) => ({
			...base,
			minHeight: 48,
			background: "#fffdf9",
			borderColor: state.isFocused ? "#b5673b" : "#ddd1bd",
			boxShadow: state.isFocused ? "0 0 0 4px rgba(181,103,59,0.18)" : "none",
			borderRadius: 10,
			cursor: "pointer",
			"&:hover": { borderColor: "#c47e54" }
		}),
		menu: (base) => ({
			...base,
			background: "#ffffff",
			border: "1px solid #ece3d4",
			borderRadius: 12,
			overflow: "hidden",
			zIndex: 30,
			boxShadow: "0 22px 48px -20px rgba(54,45,36,0.28)"
		}),
		menuPortal: (base) => ({ ...base, zIndex: 9999 }),
		menuList: (base) => ({ ...base, padding: 6 }),
		option: (base, state) => ({
			...base,
			background: state.isSelected
				? "#b5673b"
				: state.isFocused
				? "#f6e9df"
				: "transparent",
			color: state.isSelected ? "#fff" : "#2c2722",
			borderRadius: 8,
			cursor: "pointer",
			fontSize: 14
		}),
		singleValue: (base) => ({ ...base, color: "#2c2722" }),
		input: (base) => ({ ...base, color: "#2c2722" }),
		placeholder: (base) => ({ ...base, color: "#9a9082" }),
		dropdownIndicator: (base) => ({ ...base, color: "#9a9082" }),
		clearIndicator: (base) => ({ ...base, color: "#9a9082" }),
		indicatorSeparator: (base) => ({
			...base,
			background: "#ece3d4"
		})
	};

	// — Annexure report definitions (wired to existing download fns) —
	const reports = [
		{ title: "Annexure Part 1", sub: "Ranked · R1", icon: <FiHash />, run: part1download },
		{ title: "Annexure Part 2", sub: "Ranked · R2", icon: <FiHash />, run: part2download },
		{ title: "Annexure Part 3", sub: "Ranked · R3", icon: <FiHash />, run: part3download },
		{ title: "Differently Abled", sub: "DAP category", icon: <FiHeart />, run: dapdownload },
		{ title: "Sports Quota", sub: "By participation", icon: <FiAward />, run: sportsdownload },
		{ title: "Ex-Servicemen", sub: "Defence wards", icon: <FiShield />, run: exdownload },
		{ title: "NCC Cadets", sub: "Cadet quota", icon: <FiFlag />, run: nccdownload },
		{ title: "Security Forces", sub: "Gallantry / police", icon: <FiShield />, run: securityforcesdownload },
		{ title: "Andaman & Nicobar", sub: "UT candidates", icon: <FiMapPin />, run: antsdownload }
	];

	return (
		<div className="dash">
			{(downloadinflag || isloading) && (
				<div className="loaderbody">
					<div className="loader-ring" />
					<span className="downllading">
						{isloading ? "Fetching candidate records" : "Preparing your export"}
					</span>
					<span className="loader-sub">
						{isloading
							? "Loading allotment data · please wait"
							: "Compiling annexure · please wait"}
					</span>
				</div>
			)}

			<div className="dash-head">
				<span className="dash-eyebrow">
					<span className="ping" /> College&nbsp;Code&nbsp;{clgcode}
				</span>
				<h1 className="dash-title">
					Allotment <span className="grad">data console</span>
				</h1>
				<p className="dash-subtitle">
					Pull ranked, branch-wise candidate lists and generate every annexure
					export your institution needs — all from one place.
				</p>
			</div>

			{/* — Branch explorer — */}
			<section className="card dash-explorer">
				<div className="card-label">
					<span className="idx">
						<FiSearch />
					</span>
					Branch Explorer
				</div>
				<div className="explorer-controls">
					<div className="explorer-select">
						<Select
							placeholder={"Select a branch to load candidates…"}
							classNamePrefix="rs"
							styles={selectStyles}
							menuPortalTarget={document.body}
							menuPosition="fixed"
							options={options2}
							onChange={(e) => {
								setIsdatafetched(false);
								setLoading2(false);
								setbcode(e.value);
							}}
						/>
					</div>
					<button
						className="btn btn-primary"
						onClick={() => {
							// getcount();
							getdata();
						}}
					>
						<FiDatabase /> Get Data
					</button>
					{isdatafetched && (
						<CSVLink
							filename={`${clgcode}_${bcode}`}
							data={exceldownloaddata}
							className="btn btn-accent"
						>
							<FiDownload /> Download as Excel
						</CSVLink>
					)}
				</div>
			</section>

			{/* — Stat strip — */}
			{loading2 && (
				<div className="dash-stats">
					<div className="card stat">
						<div className="stat-label">
							<FiUsers /> Total Applications
						</div>
						<div className="stat-value">
							{branchwise_count}
							<span className="unit">candidates</span>
						</div>
					</div>
				</div>
			)}

			{/* — Annexure reports — */}
			<section className="card dash-annexure">
				<div className="annexure-head">
					<div className="card-label" style={{ marginBottom: 0 }}>
						<span className="idx">
							<FiLayers />
						</span>
						Annexure Reports
					</div>
					<span className="annexure-hint">
						Tap any report to download the student list as a spreadsheet
					</span>
				</div>
				<div className="report-grid">
					{reports.map((r) => (
						<button
							key={r.title}
							className="report-card"
							onClick={() => {
								setDownloadinflag(true);
								r.run();
							}}
						>
							<span className="report-ico">{r.icon}</span>
							<span className="report-text">
								<span className="report-title">{r.title}</span>
								<span className="report-sub">{r.sub}</span>
							</span>
							<FiDownloadCloud className="report-dl" />
						</button>
					))}
				</div>
			</section>

			{/* — Results — */}
			{isdatafetched ? (
				<section className="card table-panel">
					<div className="table-panel-head">
						<span className="table-panel-title">
							<FiDatabase /> Candidate Records
						</span>
						<span className="annexure-hint">
							Branch&nbsp;
							<strong style={{ color: "var(--text)" }}>{bcode}</strong>
						</span>
					</div>
					<Tableantd
						dataSource={tabledata}
						columns={columns}
						scroll={{ x: "max-content" }}
					/>
				</section>
			) : (
				<div className="dash-empty">
					<span className="empico">
						<FiInbox />
					</span>
					<h3>No data loaded yet</h3>
					<p>
						Choose a branch from the explorer above and hit{" "}
						<strong style={{ color: "var(--text)" }}>Get Data</strong> to view
						the ranked candidate list here.
					</p>
				</div>
			)}
		</div>
	);
};
